"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _datalist = _interopRequireDefault(require("../datalist"));

var _conf = _interopRequireDefault(require("../../conf"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var pad = function pad(nr) {
  return ('0' + nr).slice(-2);
};

var formatDate = function formatDate(val, row) {
  var date = new Date(row.date_register);
  return /*#__PURE__*/_react.default.createElement("span", null, "".concat(pad(date.getDate()), ".").concat(pad(date.getMonth() + 1), ".").concat(date.getFullYear()));
};

var emailState = function emailState(val, row) {
  return /*#__PURE__*/_react.default.createElement("span", {
    className: 'state-display ' + (row.email_verified ? 'color-green' : 'color-red')
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: 'icon ' + (row.email_verified ? 'icon-check' : 'icon-close')
  }));
};

var UserList = /*#__PURE__*/function (_React$Component) {
  _inherits(UserList, _React$Component);

  function UserList(props) {
    var _this;

    _classCallCheck(this, UserList);

    _this = _possibleConstructorReturn(this, (UserList.__proto__ || Object.getPrototypeOf(UserList)).call(this, props));
    _this.state = {
      userData: [],
      isLoading: false
    };
    _this.renderDetailLink = _this.renderDetailLink.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(UserList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.load();
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          i18n = _this$props.i18n;

      if (!i18n.isInitialized) {
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
          className: "loader loader--medium"
        }));
      }

      var columns = [{
        title: '',
        render: this.renderDetailLink
      }, {
        title: t('first name'),
        prop: 'first_name'
      }, {
        title: t('last name'),
        prop: 'last_name'
      }, {
        title: t('email'),
        prop: 'email'
      }, {
        title: t('city'),
        prop: 'city'
      }, {
        title: t('register date'),
        render: formatDate,
        prop: 'date_register',
        className: 'tx-right'
      }, {
        title: t('email verified'),
        render: emailState
      }];
      var staticTexts = {
        search: t('search'),
        noData: t('no data'),
        loading: t('loading data'),
        all: t('all'),
        pageSize: t('results per page')
      };
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, t('User')), /*#__PURE__*/_react.default.createElement(_datalist.default, {
        isLoading: this.state.isLoading,
        keys: "id",
        columns: columns,
        initialData: this.state.userData,
        staticTexts: staticTexts,
        useLocalStorage: true
      }));
    }
    /**
     *
     * @param val
     * @param row
     * @returns {*}
     */

  }, {
    key: "renderDetailLink",
    value: function renderDetailLink(val, row) {
      return /*#__PURE__*/_react.default.createElement("a", {
        className: "icon-link",
        href: "/user/".concat(row.id),
        title: this.props.t('Edit')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-detail"
      }));
    }
    /**
     *
     */

  }, {
    key: "load",
    value: function load() {
      var _this2 = this;

      this.setState({
        isLoading: true
      });
      fetch(_conf.default.api.userRegistrations(this.props.i18n.language), {
        credentials: 'include'
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        return _this2.setState({
          userData: json,
          isLoading: false
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }]);

  return UserList;
}(_react.default.Component);

UserList.propTypes = {
  i18n: _propTypes.default.shape({
    language: _propTypes.default.language,
    isInitialized: _propTypes.default.bool
  }),
  t: _propTypes.default.func.isRequired
};

var _default = (0, _translate.default)(UserList);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/user-list/index.js
// module id = 737
// module chunks = 0